import * as React from 'react';
export function useResizeObserver(onResize) {
  const ref = React.useRef(null);
  React.useLayoutEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }
    const observer = new ResizeObserver(entries => {
      onResize(element, entries[0]);
    });
    observer.observe(element);

    // eslint-disable-next-line consistent-return
    return () => {
      observer.disconnect();
    };
  }, [onResize]);
  return ref;
}